<template>
  <div class="w-full text-sm text-white bg-gray-light p-4">
    <div class="flex flex-row py-1">
      <div class="font-bold text-right w-1/2 pr-5">Subtotal</div>
      <div class="text-right w-1/2">£{{ subtotalPrice }}</div>
    </div>
    <div class="flex flex-row  py-1">
      <div class="font-bold text-right w-1/2 pr-5">VAT {{ tax }}%</div>
      <div class="text-right w-1/2">£ {{ taxPrice }}</div>
    </div>
    <div class="flex flex-row text-2xl font-bold pt-3">
      <div class="text-right w-1/2 pr-5">Total</div>
      <div class="text-right w-1/2">£{{ totalPrice }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ProductPrice',
  props: {
    subtotalPrice: {},
    tax: {},
    taxPrice: {},
    totalPrice: {}
  }
}
</script>